import React, { useState } from 'react';
import { List, InputItem, Picker, Button, DatePicker } from 'antd-mobile';

import { ReceiptResult, Purpose } from '../utils/const';
import { renderDate, timeFormatType } from '../utils/timeFormat';
import { CountryFilter } from '../components/CountryFilter';
import { CustomerFilter } from '../components/CommonFilter';
import ChannelFilter from '../components/ChannelFilter';

export default function Filters(props) {

  const { defaultFilters, onFilter } = props;

  const [showCalendar, setShowCalendar] = useState(false);
  const [filterValues, setFilterValues] = useState(defaultFilters);
  const [currentState, setCurrentState] = useState([])

  const onFilterChange = (fields) => {
    const values = { ...filterValues };
    Object.keys(fields).forEach(item => {
      values[item] = fields[item];
    })
    setFilterValues(values);
  };

  const onSubmit = () => {
    onFilter(filterValues)
  }
  const onReset = () => {
    setFilterValues(defaultFilters);
    setCurrentState([]);
  }

  const onCalendarConfirm = (time) => {
    setShowCalendar(false);
    onFilterChange({
      Time: time,
    })
  }

  // const getCountData = () => {
  //   let stateList = [...new Set(countryList.map(item => item.State))].map(state => ({
  //     label: state,
  //     value: state,
  //     children: countryList.filter(item => item.State === state).map(item => ({ label: `${item.BrevityCode}-${item.NameCn}`, value: item.BrevityCode }))
  //   }))
  //   return stateList
  // }

  const onChangeCountry = (v) => {
    setCurrentState(v)
    onFilterChange({ BrevityCode: v[0] })
  }

return <form>
    <List >
      <List.Item arrow="horizontal"
        onClick={() => {
          setShowCalendar(true)
        }}
        extra={renderDate(filterValues.Time, timeFormatType.date_xg)}
      >
        发送时间
      </List.Item>
      {/* <Picker
        data={getCountData()}
        title="国家/地区"
        value={currentState}
        onChange={onChangeCountry}
      >
        <List.Item arrow="horizontal">国家/地区</List.Item>
      </Picker> */}
      <CountryFilter value={currentState} onChange={onChangeCountry} />
      <InputItem value={filterValues.Phone} onChange={v => onFilterChange({ Phone: v })}>手机号</InputItem>
      <Picker
        data={Object.keys(ReceiptResult).map(item => ({ label: ReceiptResult[item], value: item }))}
        title="发送状态"
        cols={1}
        value={filterValues.ReceiptResult}
        onChange={v => onFilterChange({ ReceiptResult: v })}
      >
        <List.Item arrow="horizontal">发送状态</List.Item>
      </Picker>
      <CustomerFilter value={filterValues.OrganizationId} onChange={v => onFilterChange({ OrganizationId: v })} />
      {/* <InputItem value={filterValues.OrganizationId} onChange={v => onFilterChange({ OrganizationId: v })}>项目ID</InputItem> */}
      <InputItem value={filterValues.Content} onChange={v => onFilterChange({ Content: v })}>短信内容</InputItem>
      {/* <Picker
        data={Object.keys(CountryType).map(item => ({ label: CountryType[item], value: item }))}
        title="产品类别"
        value={filterValues.DomesticFlag}
        onChange={v => onFilterChange({ DomesticFlag: v })}
      >
        <List.Item arrow="horizontal">产品类别</List.Item>
      </Picker> */}
      <Picker
        data={Object.keys(Purpose).map(item => ({ label: Purpose[item], value: item }))}
        title="短信类型"
        value={filterValues.Purpose}
        cols={1}
        onChange={v => onFilterChange({ Purpose: v })}
      >
        <List.Item arrow="horizontal">短信类型</List.Item>
      </Picker>
      <InputItem value={filterValues.SessionID} onChange={v => onFilterChange({ SessionID: v })}>SessionID</InputItem>
      <ChannelFilter title={'下发通道'} value={filterValues.ChannelId} onChange={v => onFilterChange({ ChannelId: v })} />
      {/* <InputItem value={filterValues.ChannelId} onChange={v => onFilterChange({ ChannelId: v })}>下发通道</InputItem> */}
      <List.Item>
        <div style={{ float: 'right' }}>  
          <Button type="primary" size="small" inline onClick={onSubmit} className="mr-10">确定</Button>
          <Button size="small" inline onClick={onReset}>重置</Button>
        </div>
      </List.Item>
    </List>
    <DatePicker
      visible={showCalendar}
      mode="date"
      // value={[filterValues.BeginSendTime, filterValues.EndSendTime]}
      onOk={onCalendarConfirm}
      onDismiss={() => setShowCalendar(false)}
    />
  </form>
}